export default __webpack_public_path__ + "static/media/ot-szazalek-afa.a561bc07.webp";